import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Mui.fs.js";
import { Skeleton, CardContent, Typography, CardMedia, Card, CardActionArea } from "@mui/material";
import { RouterModule_encodeParts } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { uncurry2, createObj, int32ToString } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { cons, empty, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { empty as empty_1, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { toString } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Route_RouteState_FromInt_Z524259A4 } from "./Shared/Shared.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import { globalCtx } from "./Context.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { Route_$reflection, Vessel_$reflection } from "./Shared/ApiDataTypes.js";
import { obj_type, array_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { unwrap, map, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { toString as toString_1 } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { fromString } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { checkFetchError } from "./Utils.js";
import { ErrorHandling_snackError } from "./ViewHelpers.js";
import { map as map_1 } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { responsiveVesselCard } from "./Vessel/VesselHelpers.js";
import { responsiveRouteCard } from "./Route/RouteList.js";

export function smallVesselCard(x) {
    let elems_2, elems_1, children;
    return MuiHelpers_createElement(CardActionArea, [["href", RouterModule_encodeParts(ofArray(["vessels", int32ToString(x.Id), "info"]), 1)], ["style", {
        width: 180,
        height: 260,
        margin: 5,
        borderRadius: 4,
    }], (elems_2 = [MuiHelpers_createElement(Card, [["style", {
        width: 180,
        height: 260,
    }], (elems_1 = [MuiHelpers_createElement(CardMedia, toList(delay(() => append(singleton(["style", {
        height: 120,
        backgroundSize: "contain",
    }]), delay(() => append(singleton(["alt", `Bilde av fartøyet ${x.Name}`]), delay(() => {
        const matchValue = x.MainImageId;
        return (matchValue != null) ? singleton(["image", `/api/vessel/image/${matchValue}/thumbnail`]) : singleton(["image", "/images/FerryPictureDefaultThumbnail.png"]);
    }))))))), (children = ofArray([MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", x.Name]]), MuiHelpers_createElement(Typography, [["variant", "caption"], ["component", "p"], ["children", x.CallSign]]), MuiHelpers_createElement(Typography, [["variant", "caption"], ["children", toString(x.Status)]])]), MuiHelpers_createElement(CardContent, [["children", reactApi.Children.toArray(Array.from(children))]]))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])], ["children", reactApi.Children.toArray(Array.from(elems_2))])]);
}

export function smallRouteCard(x) {
    let elems_2, elems_1, children;
    return MuiHelpers_createElement(CardActionArea, [["href", RouterModule_encodeParts(ofArray(["routes", int32ToString(x.Id), "info"]), 1)], ["style", {
        width: 180,
        height: 260,
        margin: 5,
        borderRadius: 4,
    }], (elems_2 = [MuiHelpers_createElement(Card, [["style", {
        width: 180,
        height: 260,
    }], (elems_1 = [MuiHelpers_createElement(CardMedia, [["style", {
        height: 120,
        backgroundSize: "contain",
    }], ["alt", `Bilde av fartøyet ${x.Name}`], ["image", "/images/route_default.jpg"]]), (children = ofArray([MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", x.Name]]), MuiHelpers_createElement(Typography, [["variant", "caption"], ["component", "p"], ["children", x.Number]]), MuiHelpers_createElement(Typography, [["variant", "caption"], ["children", toString(Route_RouteState_FromInt_Z524259A4(x.Status))]])]), MuiHelpers_createElement(CardContent, [["children", reactApi.Children.toArray(Array.from(children))]]))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])], ["children", reactApi.Children.toArray(Array.from(elems_2))])]);
}

function noContent(target) {
    let elems_1, elems, props_2;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        width: 100 + "%",
        maxWidth: 700,
        alignItems: "center",
        justifyContent: "center",
        padding: 1 + "vw",
        backgroundColor: "rgba(0, 0, 0, 0.08)",
        borderRadius: 4,
        minHeight: 200,
    }], (elems_1 = [MuiHelpers_createElement(Typography, [["children", `Slik lagrer du dine ${target} for raskere oversikt:`]]), MuiHelpers_createElement(Typography, [["style", {
        marginTop: 10,
    }], (elems = [`Finn et ${target}, trykk `, (props_2 = {
        style: {
            fontSize: 1 + "rem",
        },
    }, react.createElement(FavoriteBorder, props_2)), " i høyre hjørne"], ["children", reactApi.Children.toArray(Array.from(elems))])])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function feedback() {
    let value_7;
    return createElement("iframe", createObj(ofArray([["style", {
        border: "none",
    }], ["width", 640], ["height", 480], (value_7 = "https://forms.office.com/Pages/ResponsePage.aspx?id=ELHF_vEjV0C8b2iw1RUY-EAG-gqPKsVKrlf944EGaFxUQ0c1T1ZTVFdQOEdPUlE1UzZBUjRVV0s5WC4u&embed=true", ["src", value_7])])));
}

export function Home() {
    let elems_3;
    const ctx = reactApi.useContext(globalCtx);
    const patternInput = reactApi.useState(undefined);
    const vessels = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const routes = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setError = patternInput_2[1];
    let isMobile;
    const matchValue = ctx.Responsive;
    switch (matchValue.tag) {
        case 0:
        case 1: {
            isMobile = true;
            break;
        }
        default:
            isMobile = false;
    }
    useEffectOnce(() => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Vessel_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString_1(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/vessel/favorites", properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Vessel_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                            let matchValue_1;
                            return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_2) => {
                const res = _arg_2;
                if (res.tag === 1) {
                    checkFetchError(res.fields[0]);
                    setError("Kunne ikke laste \"Mine fartøy\". Vennligst prøv igjen senere");
                    return Promise.resolve();
                }
                else {
                    patternInput[1](res.fields[0]);
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
        const pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder_3, data_5, caseStrategy_10, extra_10;
            return ((decoder_3 = Auto_generateBoxedDecoder_Z6670B51(array_type(Route_$reflection()), undefined, undefined), (data_5 = undefined, (caseStrategy_10 = undefined, (extra_10 = undefined, (() => {
                let properties_6;
                try {
                    const properties_3_1 = Helper_withProperties(empty(), (properties_6 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString_1(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_10), unwrap(extra_10))(data_1_2))]), properties_6), data_5), properties_6)));
                    const pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/route/favorites", properties_3_1).then((_arg_3) => {
                        let response_3, decoder_1_2;
                        return ((response_3 = _arg_3, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Route_$reflection()), unwrap(caseStrategy_10), unwrap(extra_10))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_3.text().then((_arg_4) => {
                            let matchValue_2;
                            return Promise.resolve((matchValue_2 = fromString(uncurry2(decoder_1_2), _arg_4), (matchValue_2.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_2.fields[0]])])) : (new FSharpResult$2(0, [matchValue_2.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
                    }))));
                    return pr_2.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])]))));
                }
                catch (exn_1) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
                }
            })()))))).then((_arg_5) => {
                const res_1 = _arg_5;
                if (res_1.tag === 1) {
                    checkFetchError(res_1.fields[0]);
                    setError("Kunne ikke laste \"Mine samband\". Vennligst prøv igjen senere");
                    return Promise.resolve();
                }
                else {
                    patternInput_1[1](res_1.fields[0]);
                    return Promise.resolve();
                }
            });
        }));
        pr_3.then();
    });
    const loading = () => MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
        width: 100 + "%",
        maxWidth: 700,
        minHeight: 220,
    }]]);
    const container = (children) => createElement("div", {
        style: createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "row"]), delay(() => append(singleton(["flexWrap", "wrap"]), delay(() => append(singleton(["gap", 1 + "rem"]), delay(() => (isMobile ? append(singleton(["maxWidth", 90 + "vw"]), delay(() => singleton(["alignItems", "center"]))) : empty_1())))))))))))),
        children: reactApi.Children.toArray(Array.from(children)),
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        padding: 2 + "vw",
    }], (elems_3 = [ErrorHandling_snackError(patternInput_2[0], () => {
        setError(undefined);
    }), MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", "Mine fartøy"]]), container(toList(delay(() => {
        if (vessels != null) {
            const x_4 = vessels;
            return (x_4.length === 0) ? singleton(noContent("fartøy")) : singleton(map_1((x_5) => {
                let elems_1;
                return createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexGrow", 1]), delay(() => append(singleton(["flexBasis", 0]), delay(() => append(singleton(["flexShrink", 1]), delay(() => (isMobile ? singleton(["minWidth", 250]) : append(singleton(["minWidth", 225]), delay(() => singleton(["maxWidth", 225])))))))))))))))], (elems_1 = [responsiveVesselCard([["height", 280]], x_5, undefined, "", true, (value_49) => {
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
            }, x_4));
        }
        else {
            return singleton(loading());
        }
    }))), MuiHelpers_createElement(Typography, [["variant", "h4"], ["style", {
        marginTop: 1 + "vw",
    }], ["children", "Mine samband"]]), container(toList(delay(() => {
        if (routes != null) {
            const x_6 = routes;
            return (x_6.length === 0) ? singleton(noContent("samband")) : singleton(map_1((x_7) => {
                let elems_2;
                return createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexGrow", 1]), delay(() => append(singleton(["flexBasis", 0]), delay(() => append(singleton(["flexShrink", 1]), delay(() => append(isMobile ? singleton(["minWidth", 250]) : append(singleton(["minWidth", 225]), delay(() => singleton(["maxWidth", 225]))), delay(() => singleton(["margin", 0.5 + "rem"]))))))))))))))], (elems_2 = [responsiveRouteCard([["height", 280]], x_7, "")], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
            }, x_6));
        }
        else {
            return singleton(loading());
        }
    })))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

//# sourceMappingURL=Home.js.map
